declare const I18n;

import * as React from "react";
import { UberTable, RowDefinition } from "./UberTable";

export type LearnerStats = {
  id: number;
  name: string;
  courses_completed: number;
  resources_completed: number;
  lite_bytes_completed: number;
  last_badge_earned_at: string | null; // ISO timestamp from Rails
};

type Props = {};

class LearnersStatsTable extends React.Component<Props> {
  private rowDefinition: RowDefinition<LearnerStats>[];

  constructor(props: Props) {
    super(props);

    this.rowDefinition = [
      {
        title: I18n.t("models.common.name"),
        attribute_key: "name",
        sort_key: "name",
        render: (row: LearnerStats) => {
          return (
            <a href={`/learners/${row.id}/edit`}>{row.name}</a>
          )
        },
      },
      {
        title: I18n.t("views.learners.index.tables.courses"),
        attribute_key: "courses_completed",
        sort_key: "courses_completed",
        textAlignment: "center",
        render: (row: LearnerStats) => {
          const count = row.courses_completed ?? 0;
          return (<a
            href={`/learners/${row.id}/courses`}
            className="btn btn-link pt-0"
          >{I18n.t("views.learners.index.tables.courses_completed", { count })}</a>);
        },
      },
      {
        title: I18n.t("views.learners.index.tables.resources"),
        attribute_key: "resources_completed",
        sort_key: "resources_completed",
        textAlignment: "center",
        render: (row: LearnerStats) => {
          const count = row.resources_completed ?? 0;
          return I18n.t("views.learners.index.tables.courses_completed", { count });
        },
      },
      {
        title: I18n.t("views.learners.index.tables.lite_bytes"),
        attribute_key: "lite_bytes_completed",
        sort_key: "lite_bytes_completed",
        textAlignment: "center",
        render: (row: LearnerStats) => {
          const count = row.lite_bytes_completed ?? 0;
          return I18n.t("views.learners.index.tables.courses_completed", { count });
        },
      },
      {
        title: I18n.t("views.learners.index.tables.achievements"),
        attribute_key: "learner_achievements",
        sort_key: "learner_achievements",
        render: (row: LearnerStats) => {
          return (
            <a href={`/learners/${row.id}/achievements`}>{I18n.t("views.learners.index.tables.view_achievements")}</a>
          )
        },
      },
    ];
  }

  render() {
    return (
      <UberTable<LearnerStats>
        rowDefinition={this.rowDefinition}
        searchType="learners-stats"
        omitOptions={true}
        {...this.props}
      />
    );
  }
}

export default LearnersStatsTable;
